import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { AuthService, PopupsService } from '@services';
import { ConstantsUtil } from '@utils';
import { Popups, Routes } from '@enums';
import { Button, Popup } from '@elements';
/**
 * Not receive code component.
 *
 * @author Christina Kashevar
 * @function NotReceiveCode
 * @category components
 * @param {PopupProps} popup props.
 * @return {FC} popup component.
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var NotReceiveCode = function NotReceiveCode(_ref) {
  var _location$state, _popUp$data;

  var popUp = _ref.popUp;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var intervalId = useRef();
  var TIMER_SIZE = 10;

  var _useState = useState(TIMER_SIZE),
      _useState2 = _slicedToArray(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1];

  var location = useLocation();
  var phoneNumber = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.phoneNumber;
  var navigate = useNavigate();
  useEffect(function () {
    if (!timer) {
      clearInterval(intervalId.current);
      return;
    }

    intervalId.current = setInterval(function () {
      setTimer(timer - 1);
    }, 1000);
    return function () {
      return clearInterval(intervalId.current);
    };
  }, [timer]);
  /**
   * Retry timer handler.
   *
   * @function onRetryTimer
   * @author Ihar Kazlouski
   * @return {void}
   */

  var onRetryTimer = function onRetryTimer() {
    void _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$AuthService$ap, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return AuthService.apiSendPhonePost({
                body: {
                  phoneNumber: phoneNumber
                }
              });

            case 3:
              _yield$AuthService$ap = _context.sent;
              data = _yield$AuthService$ap.data;
              PopupsService.close(Popups.NotReceiveCode);
              navigate(Routes.Sms, {
                state: {
                  attempt: data,
                  phoneNumber: phoneNumber
                }
              });
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              navigate(Routes.Login);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }))();
  };
  /**
   * Close pop up.
   *
   * @function onRetryTimer
   * @author Ihar Kazlouski
   * @return {void}
   */


  var handleCancel = function handleCancel() {
    PopupsService.close(Popups.NotReceiveCode);
  };

  return /*#__PURE__*/_jsxs(Popup, {
    popUp: popUp,
    maxWidth: popUp === null || popUp === void 0 ? void 0 : (_popUp$data = popUp.data) === null || _popUp$data === void 0 ? void 0 : _popUp$data.maxWidth,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: t('components.popups.resendOtp')
    }), /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "body2",
            color: "comet",
            textAlign: "center",
            children: t('components.popups.notReceiveCode.notification')
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "body2",
            color: "comet",
            textAlign: "center",
            mt: 3,
            children: t('components.popups.notReceiveCode.wait')
          })]
        }), /*#__PURE__*/_jsxs(Box, {
          pt: 4.5,
          display: "flex",
          gap: 1.5,
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "outlined",
            color: "comet",
            size: "small",
            sx: {
              whiteSpace: 'nowrap'
            },
            onClick: onRetryTimer,
            disabled: timer >= 1,
            children: timer < 1 ? t('components.popups.notReceiveCode.resend') : "".concat(t('components.popups.notReceiveCode.resend'), " in ").concat(timer, " sec.")
          }), /*#__PURE__*/_jsx(Button, {
            variant: "outlined",
            color: "comet",
            size: "small",
            component: "a",
            href: "mailto:".concat(ConstantsUtil.email, "?subject=Admin Console feedback"),
            children: t('components.popups.notReceiveCode.contactSupport')
          }), /*#__PURE__*/_jsx(Button, {
            variant: "outlined",
            color: "comet",
            size: "small",
            onClick: handleCancel,
            children: t('components.popups.cancel')
          })]
        })]
      })
    })]
  });
};

export { NotReceiveCode };